// extracted by mini-css-extract-plugin
export default {"AboutUs":"aboutUs_AboutUs__F8LXn","title":"aboutUs_title__lyDhT","px20":"aboutUs_px20__930ui","px18":"aboutUs_px18__zEAj+"};